import { render, staticRenderFns } from "./receiveHistory.vue?vue&type=template&id=8a549394"
import script from "./receiveHistory.vue?vue&type=script&lang=js"
export * from "./receiveHistory.vue?vue&type=script&lang=js"
import style0 from "./receiveHistory.vue?vue&type=style&index=0&id=8a549394&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports